import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export function PriceEvolutionChartCard({ selectedProducts, availableProducts, priceEvolutionData, timeRange, onTimeRangeChange }) {
  const priceData = priceEvolutionData || [];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-card p-3" style={{ border: '1px solid var(--color-border)' }}>
          <p className="small mb-2">{label}</p>
          {payload.map((entry, index) => (
            <p key={index} className="small mb-1" style={{ color: entry.color }}>
              {entry.name}: R${entry.value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="card custom-card h-100">
      <div className="card-body p-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h3 className="h5 fw-semibold mb-0">Evolução de Preço por Produto</h3>
          <select
            className="form-select form-select-sm"
            value={timeRange}
            onChange={(e) => onTimeRangeChange(e.target.value)}
            style={{
              backgroundColor: 'var(--color-surface-raised)',
              border: '1px solid var(--color-border)',
              color: 'var(--color-text-primary)',
              maxWidth: '150px'
            }}
          >
            <option value="6">Últimos 6 meses</option>
            <option value="12">Último ano</option>
            <option value="all">Todo o período</option>
          </select>
        </div>

        {selectedProducts.length === 0 ? (
          <div className="d-flex align-items-center justify-content-center" style={{ height: '280px' }}>
            <p className="text-muted-custom">Selecione produtos para ver a evolução de preço.</p>
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={280}>
            <LineChart data={priceData}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
              <XAxis
                dataKey="month"
                stroke="var(--color-text-secondary)"
                style={{ fontSize: '12px' }}
              />
              <YAxis
                stroke="var(--color-text-secondary)"
                style={{ fontSize: '12px' }}
                tickFormatter={(value) => `R$${value}`}
              />
              <Tooltip content={<CustomTooltip />} />
              <Legend
                wrapperStyle={{ fontSize: '12px', color: 'var(--color-text-secondary)' }}
                iconType="circle"
              />
              {selectedProducts.map(id => {
                const product = availableProducts.find(p => p.id === id);
                if (!product) return null;
                return (
                  <Line
                    key={id}
                    type="monotone"
                    dataKey={product.name}
                    stroke={product.color}
                    strokeWidth={2}
                    dot={{ fill: product.color, r: 4 }}
                    name={product.name}
                    connectNulls
                  />
                );
              })}
            </LineChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}
